import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { IconWithCountIconWrapper } from 'src/styles';

const activityIndicator = css({
  '&::after': {
    background: token('color.background.accent.teal.subtle'),
    border: `2px solid ${token('color.border.inverse')}`,
    borderRadius: '100%',
    content: "''",
    display: 'block',
    height: '8px',
    left: '-1px',
    position: 'absolute',
    top: 0,
    width: '8px',
  },
});

export const IconContainer = styled(IconWithCountIconWrapper)<{
  hasUnseenActivity?: boolean;
}>(
  {
    position: 'relative',
  },
  ({ hasUnseenActivity }) => hasUnseenActivity && activityIndicator
);
